import React, { useState, useEffect, useRef } from "react";
import CreateAvatarFromScript from "./FromScript/CreateAvatarFromScript";
import CustomAvatar from "./CustomAvatar/CustomAvatar";
import {
  Grid,
  Card,
  CardContent,
  CardMedia,
  Typography,
  Box,
  Button,
  CircularProgress,
  Slider,
  Pagination,
  Popover,
  FormControl,
  MenuItem,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import Heygen_Avatar_Creation from "../../../../../assets/Heygen/Heygen_Avatar_Creation.png";
import { uploadFiles_button_hovered_bg_color } from "../../../../../constants/colors";
import introimage from "../../../../../assets/Heygen/IntroImage.png";
import secondoption from "../../../../../assets/Heygen/AIoptionsecond.png";
import ClearIcon from "@mui/icons-material/Clear";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import AutoFixHighOutlinedIcon from "@mui/icons-material/AutoFixHighOutlined";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloseIcon from "@mui/icons-material/Close";
import preview_image from "../../../../../assets/Heygen/GirlImageforHeygenAvatarPreview.png";
import {
  DeleteAvatarForHeygen,
  FetchAllAvatarsForHeygen,
  FetchAllAvatarsLooks,
  GetPersonalAvatarData,
} from "../../../../../contexts/WorkspaceUtils";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { useWorkspace } from "../../../../../contexts/WorkspaceContext";
import CommonToast from "../../../../Common_Components/CommonToast";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import defaultImageForAvatar from "../../../../../assets/PersonalAvatarIcon/Personal Avatar.png";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import DeleteIcon from "@mui/icons-material/Delete";
import GroupsIcon from "@mui/icons-material/Groups";
import AddLook from "./AddLook";

// const AvatarStyle = [
//   { id: 1, name: "Normal", value: "normal" },
//   { id: 2, name: "Close-up", value: "close-up" },
//   { id: 3, name: "Cirlce", value: "cirlce" },
// ];

const allFilterVoiceGender = [
  { id: 0, name: "All", gender: "" },
  { id: 1, name: "Male", gender: "male" },
  { id: 2, name: "Female", gender: "female" },
];

const AvatarCreation = (props) => {
  // Personal Avatars State
  const [activeView, setActiveView] = useState("selection");
  // const [showAvatarCreation, setShowAvatarCreation] = useState(false);
  const [showCustomAvatar, setShowCustomAvatar] = useState(false);
  const [personalAvatar, setPersonalAvatar] = useState([]);
  const [hoveredCardIndex, setHoveredCardIndex] = useState(null);
  const [selectedAvatar, setSelectedAvatar] = useState(null);
  const [hoverForDeleteButton, setHoverForDeleteButton] = useState(false);
  const [moreOptionIndex, setMoreOptionIndex] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [currentWindow, setCurrentWindow] = useState(1);
  const [selectedHeygenAvatarStyle, setSelectedHeygenAvatarStyle] = useState({
    id: 1,
    name: "Normal",
    value: "normal",
  });
  const [offsetValue, setOffsetValue] = useState({ x: 0, y: 0 });

  // System Avatars State
  const [systemAvatars, setSystemAvatars] = useState([]);
  const [avatarsLoading, setAvatarsLoading] = useState(false);
  const [inputBoxValue, setInputBoxValue] = useState("");
  const [filterAvatars, setFilterAvatars] = useState(null);

  const {
    heygenVideoPersonalAvatarGroupId,
    setHeygenVideoPersonalAvatarGroupId,
    selectedAvatarForHeygenVideo,
    setSeletedAvatarForHeygenVideo,
    heygenAvatarOffset,
    setHeygenAvatarOffset,
    heygenAvatarScale,
    setHeygenAvatarScale,
    heygenAvatarStyle,
    setHeygenAvatarStyle,
    heygenVideoPersonalAvatarImageId,
    setHeygenVideoPersonalAvatarImageId,
    isModalOpenForAvatarGenerationOption,
    setIsModalOpenForAvatarGenerationOption,
    showAvatarCreation,
    setShowAvatarCreation,
    subscribeType,
  } = useWorkspace();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(Math.floor(1197 / 10));
  const [gender, setGender] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [openToast, setOpen] = useState(false);
  const [content, setContent] = useState("");
  const [iconType, setIconType] = useState("success");
  const [bgColor, setBgColor] = useState("#282D51");
  const [personalAvatarLoader, setPersonalAvatarLoader] = useState(false);
  const [avatarToDelete, setAvatarToDelete] = useState(null);
  const [openAddLookModal, setOpenAddLookModal] = useState(false);
  const [activeAvatar, setActiveAvatar] = useState(null);
  const pollingIntervalRef = useRef(null);
  const isFirstCallDoneRef = useRef(false);

  const theme = localStorage.getItem("theme");

  const [showSystemAvatarLooks, setShowSystemAvatarLooks] = useState(false);
  const [selectedSystemAvatar, setSelectedSystemAvatar] = useState(null);
  const [groupId, setGroupId] = useState(null);
  const [avatarLooks, setAvatarLooks] = useState([]);

  // Custom theme for Material UI Pagination
  const paginationTheme = createTheme({
    typography: {
      fontFamily: "Inter",
    },
    components: {
      MuiPagination: {
        styleOverrides: {
          root: {
            "& .MuiPaginationItem-root": {
              color: "#ffffff",
              borderRadius: "20px",
              "&:hover": {
                backgroundColor: "rgba(179, 168, 183, 0.26)",
              },
              fontSize: "14px",
            },
            "& .MuiPaginationItem-page.Mui-selected": {
              backgroundColor: "#CAC4D0",
              color: "black",
              "&:hover": {
                backgroundColor: "#CAC4D0",
              },
            },
            "& .MuiPaginationItem-ellipsis": {
              color: "#ffffff",
            },
            "& .MuiPaginationItem-previousNext": {
              color: "#ffffff",
              borderRadius: "20px",
            },
          },
        },
      },
    },
  });

  // Fetch Personal Avatars
  // const fetchPersonalAvatars = async () => {
  //   setPersonalAvatarLoader(true)
  //     try {
  //       // Replace with your actual API call
  //       const response = await GetPersonalAvatarData();
  //       const res = await response.json()
  //       console.log("res", res)
  //       setPersonalAvatar(res?.data);
  //       // Mock data
  //       // setPersonalAvatar([
  //         // { id: 1, name: 'My Avatar 1', image_url: "", status: 'done' },
  //         // { id: 2, name: 'My Avatar 2', image_url: "", status: 'done' }
  //       // ]);
  //     } catch (error) {
  //       console.error("Error fetching avatars:", error);
  //     }
  //     setPersonalAvatarLoader(false)
  //   };

  //     useEffect(() => {
  //       fetchPersonalAvatars();
  //     }, [setIsModalOpenForAvatarGenerationOption,showAvatarCreation]);

  const fetchPersonalAvatars = async () => {
    try {
      if (!isFirstCallDoneRef.current) {
        setPersonalAvatarLoader(true);
      }

      const response = await GetPersonalAvatarData();
      const res = await response.json();
      const data = res?.data || [];

      // ✅ Always update UI on first fetch
      if (!isFirstCallDoneRef.current) {
        setPersonalAvatar(data);
        isFirstCallDoneRef.current = true;
      }

      const hasPending = data?.some((avatar) => avatar?.status == "pending");
      if (hasPending) {
        // 🕒 Start polling if status is pending
        pollingIntervalRef.current = setTimeout(fetchPersonalAvatars, 2000);
      } else {
        // ✅ Update final state & stop polling
        setPersonalAvatar(data);
        clearTimeout(pollingIntervalRef.current);
        pollingIntervalRef.current = null;
      }
    } catch (error) {
      console.error("Error fetching avatars:", error);
    } finally {
      setPersonalAvatarLoader(false);
    }
  };

  useEffect(() => {
    isFirstCallDoneRef.current = false;
    fetchPersonalAvatars();

    // 🧹 Clean up on unmount
    return () => {
      if (pollingIntervalRef.current) {
        clearTimeout(pollingIntervalRef.current);
      }
    };
  }, [showAvatarCreation]); // Depends on your logic to trigger refetch

  // Fetch System Avatars
  const fetchSystemAvatars = async () => {
    setAvatarsLoading(true);
    try {
      // Replace with your actual API call
      const response = await FetchAllAvatarsForHeygen(
        currentPage,
        gender?.gender
      );
      const res = await response.json();
      // console.log("res", res?.data?.data?.personalAvatar)

      // Mock data
      // setSystemAvatars([
      //   { id: 'sys1', name: 'Avatar 1', image_url: "https://example.com/avatar1.jpg" },
      //   { id: 'sys2', name: 'Avatar 2', image_url: "https://example.com/avatar2.jpg" },
      //   { id: 'sys3', name: 'Avatar 3', image_url: "https://example.com/avatar3.jpg" },
      //   { id: 'sys4', name: 'Avatar 4', image_url: "https://example.com/avatar4.jpg" }
      // ]);
      setSystemAvatars(res?.data?.data?.personalAvatar);
      setTotalPage(Math.floor(res?.data?.totalRows / 10));
    } catch (error) {
      console.error("Error fetching system avatars:", error);
    }
    setAvatarsLoading(false);
  };
  useEffect(() => {
    fetchSystemAvatars();
  }, [currentPage, gender]);

  // Search Filter Effect
  useEffect(() => {
    const handler = setTimeout(() => {
      const filterValue = systemAvatars?.filter((item) =>
        item?.avatar_name?.toLowerCase().includes(inputBoxValue.toLowerCase())
      );
      setFilterAvatars(filterValue);
    }, 300);

    return () => {
      clearTimeout(handler);
    };
  }, [inputBoxValue, systemAvatars]);

  const fetchDefaultAvatarLooks = async () => {
    setAvatarsLoading(true);
    try {
      const response = await FetchAllAvatarsLooks(groupId);
      const res = await response.json();

      setAvatarLooks(res?.data);
    } catch (error) {
      console.error("Error fetching system avatars looks:", error);
    }
    setAvatarsLoading(false);
  };

  useEffect(() => {
    if (groupId) {
      fetchDefaultAvatarLooks();
    }
  }, [groupId]);

  useEffect(() => {
    if (!showSystemAvatarLooks) {
      setAvatarLooks([]);
    }
  }, [showSystemAvatarLooks]);

  // Modal Functions
  const toggleModal = () => {
    // alert("Coming Soon")
    // setOpen(true)
    // setContent("Coming Soon")
    // setIconType("success")

    setIsModalOpenForAvatarGenerationOption(
      !isModalOpenForAvatarGenerationOption
    );
    if (!isModalOpenForAvatarGenerationOption) {
      setActiveView("selection");
      setShowCustomAvatar(false);
      setShowAvatarCreation(false);
    }
  };

  const handleOptionSelect = (type) => {
    if (type === "custom") {
      setShowCustomAvatar(true);
    } else if (type === "ai") {
      // setOpen(true)
      // setContent("Coming Soon")
      // setIconType("success")
      setShowAvatarCreation(true);
    }
  };

  const handleCloseAvatarCreation = () => {
    setShowAvatarCreation(false);
    setActiveView("selection");
  };

  const handleCloseCustomAvatar = () => {
    setShowCustomAvatar(false);
    setActiveView("selection");
  };

  // Avatar Selection Handlers
  const handleAvatarSelect = (avatar) => {
    // if (avatar?.status === 'done') {
    //   setSelectedAvatar(avatar);
    //   toggleModal();
    // }
    if (avatar.status == "pending" || avatar.status == "moderation_rejected") {
      setOpen(true);
      setContent("Sorry You Cannot Select Pending or Reject Avatar");
      setIconType("error");
      return;
    }
    setHeygenVideoPersonalAvatarImageId(avatar?.group_id);
    setHeygenVideoPersonalAvatarGroupId(avatar?.group_id);
    setSelectedAvatar(avatar);
    setSeletedAvatarForHeygenVideo(avatar);

    // Only update timeline items if the props are provided (from VideoGenerate.jsx)
    if (
      props.timelineItems &&
      typeof props.timelineItems === "function" &&
      props.activeTimelineItem !== undefined
    ) {
      props.timelineItems((prevItems) => {
        const items = [...prevItems];

        items[props.activeTimelineItem] = {
          ...items[props.activeTimelineItem],
          thumbnail: avatar?.image_url || avatar?.preview_image_url,
          avatar: "",
          talkingphoto: avatar?.group_id || avatar.looks_id,
        };

        return items;
      });
    }
  };

  const handleSystemAvatarSelect = (avatar) => {
    setGroupId(avatar?.avatar_id);
    setSelectedSystemAvatar(avatar);
    setShowSystemAvatarLooks(true);
    setCurrentPage(1);

    //setHeygenVideoPersonalAvatarImageId(null);
    //setHeygenVideoPersonalAvatarGroupId(null);
    //setSelectedAvatar(avatar);
    // Additional logic for system avatar selection
    //setSeletedAvatarForHeygenVideo(avatar);
  };

  const handleBackFromLooks = () => {
    setShowSystemAvatarLooks(false);
    setSelectedSystemAvatar(null);
    setGroupId(null);
    setAvatarLooks([]);
  };

  const handleLookSelect = (look) => {
    console.log("Selected look:", look);

    setHeygenVideoPersonalAvatarImageId(null);
    setHeygenVideoPersonalAvatarGroupId(null);
    setSelectedAvatar(look);
    setSeletedAvatarForHeygenVideo(look);
    // setShowSystemAvatarLooks(false);
    setSelectedSystemAvatar(null);
    setGroupId(null);
    // setSystemAvatars([]);

    // Only update timeline items if the props are provided (from VideoGenerate.jsx)
    if (
      props.timelineItems &&
      typeof props.timelineItems === "function" &&
      props.activeTimelineItem !== undefined
    ) {
      props.timelineItems((prevItems) => {
        const items = [...prevItems];

        items[props.activeTimelineItem] = {
          ...items[props.activeTimelineItem],
          thumbnail: look.preview_image_url,
          avatar: look.avatar_id,
          talkingphoto: look.looks_id,
        };

        return items;
      });
    }
    //toggleModal();
  };

  // More Options Functions
  const handleClickMoreOption = (e, avatar, index) => {
    e.stopPropagation();
    setMoreOptionIndex(moreOptionIndex === index ? null : index);
    setAvatarToDelete(avatar?.group_id);
  };

  const handleDeleteAvatar = async () => {
    // Implement your delete logic here
    // console.log("Deleting avatar:", avatarToDelete);
    try {
      const deleteAvatar = await DeleteAvatarForHeygen(avatarToDelete);
      const responseData = await deleteAvatar.json();
      if (responseData.status) {
        setOpen(true);
        setIconType("success");
        setContent(responseData?.message);
      } else {
        setOpen(true);
        setIconType("error");
        setContent(responseData?.message);
      }
    } catch (error) {
      console.log("error", error);
    }
    setPersonalAvatar(
      personalAvatar.filter((avatar) => avatar.group_id !== avatarToDelete)
    );
    setShowDeleteModal(false);
    setMoreOptionIndex(null);
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setMoreOptionIndex(null);
  };

  const openDeleteModal = () => {
    setShowDeleteModal(true);
    setMoreOptionIndex(null);
  };

  const handlePageChange = (event, value) => {
    setCurrentPage(value); // Update the current page when a page is clicked
  };

  const onClose = () => {
    setOpen(false);
  };

  const handleSelectGender = (ele) => {
    setGender(ele);
    handleClose();
  };

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleScaleSelectionButtonClick = (style) => {
    console.log("style", style);
    setSelectedHeygenAvatarStyle(style);
    setHeygenAvatarStyle(style?.value);
  };

  const HandleResetButtonClick = () => {
    setHeygenAvatarOffset({ x: 0, y: 0 });
    setSelectedHeygenAvatarStyle({ id: 1, name: "Normal", value: "normal" });
    setHeygenAvatarStyle("normal");
    setHeygenAvatarScale(1);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        moreOptionIndex !== null &&
        !event.target.closest(".delete-option-container")
      ) {
        setMoreOptionIndex(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [moreOptionIndex]);

  const handleAddLookModalClick = () => {
    setOpenAddLookModal(true);
  };

  const handleAddLookModalClose = () => {
    setOpenAddLookModal(false);
    setActiveAvatar(null);
  };

  return (
    <>
      {currentWindow == 1 ? (
        <div>
          {/* Personal Avatars Section */}
          <Box sx={{ marginTop: "20px", padding: "0px" }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <Typography
                sx={{
                  color: "#FFF",
                  fontFamily: "Inter",
                  fontSize: "16px",
                  fontStyle: "normal",
                  fontWeight: 500,
                  lineHeight: "20px",
                  marginBottom: "8px",
                }}
              >
                Select Avatar
              </Typography>
              {/* <Box>
                <Button
                  onClick={() => {
                    setCurrentWindow(2);
                  }}
                  sx={{
                    display: "flex",
                    justifyContent: "space-around",
                    textTransform: "none",
                    border: "1px solid rgba(255, 255, 255, 0.10)",
                    padding: "8px 12px 8px 12px",
                    gap: "10px",
                    marginLeft: "20px",
                    bgcolor: "#2F355F",
                    borderRadius: "8px",
                    "&:hover": { bgcolor: "#373E6D" },
                    "&:active": { bgcolor: "#2F355F" },
                  }}
                >
                  <Box
                    sx={{
                      width: "17px",
                      borderRadius: "50%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      color: "#FFFFFF",
                    }}
                  >
                    <SettingsOutlinedIcon
                      sx={{ width: "18px", height: "18px" }}
                    />
                  </Box>
                  <Box
                    sx={{
                      height: "20px",
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "Inter",
                        fontStyle: "normal",
                        fontSize: "14px",
                        fontWeight: 400,
                        lineHeight: "20px",
                        color: "#FFFFFF",
                      }}
                    >
                      Advanced settings
                    </Typography>
                  </Box>
                </Button>
              </Box> */}
            </Box>
            {subscribeType >= 3 ? (
              <div>
                <Typography
                  sx={{
                    color: "#FFF",
                    fontFamily: "Inter",
                    fontSize: "14px",
                    fontStyle: "normal",
                    fontWeight: 500,
                    lineHeight: "20px",
                    marginBottom: "16px",
                  }}
                >
                  Personal avatars
                </Typography>

                <div>
                  {!personalAvatar.length && !personalAvatarLoader && (
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        border: "1px solid rgba(255, 255, 255, 0.20)",
                        borderRadius: "16px",
                        padding: "16px",
                        height: "150px",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-between",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            rowGap: "12px",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              columnGap: "12px",
                            }}
                          >
                            <Typography
                              component="p"
                              sx={{
                                color: "#ffffff",
                                fontFamily: "Inter",
                                fontSize: "16px",
                                fontStyle: "normal",
                                fontWeight: 500,
                                lineHeight: "normal",
                              }}
                            >
                              Create your personal AI avatar
                            </Typography>
                            <Box
                              sx={{
                                bgcolor: "rgba(246, 190, 107, 0.20)",
                                border: "1px solid #F6BE6B",
                                borderRadius: "4px",
                                margin: "0px",
                                padding: "0px",
                              }}
                            >
                              <Typography
                                sx={{
                                  fontFamily: "Inter",
                                  fontSize: "12px",
                                  fontStyle: "normal",
                                  fontWeight: 600,
                                  lineHeight: "16px",
                                  letterSpacing: "0.1px",
                                  color: "#F6BE6B",
                                  padding: "2px 4px",
                                  margin: "0px",
                                }}
                              >
                                New
                              </Typography>
                            </Box>
                          </Box>
                          <Typography
                            sx={{
                              color: "rgba(255, 255, 255, 0.80)",
                              fontFamily: "Inter",
                              fontSize: "14px",
                              fontStyle: "normal",
                              fontWeight: 400,
                              lineHeight: "normal",
                            }}
                          >
                            Create lifelike, high quality videos with your
                            personal digital AI clone
                          </Typography>
                        </Box>
                        <Button
                          onClick={toggleModal}
                          variant="contained"
                          sx={{
                            backgroundColor: "white",
                            width: "156px",
                            height: "40px",
                            borderRadius: "8px",
                            display: "flex",
                            padding: "10px 12px",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: "8px",
                            alignSelf: "stretch",
                            "&:hover": {
                              backgroundColor:
                                uploadFiles_button_hovered_bg_color,
                            },
                          }}
                        >
                          <Box
                            sx={{
                              height: "40px",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <Typography
                              component="span"
                              sx={{
                                color: "#17182C",
                                fontFamily: "Inter",
                                fontSize: "16px",
                                fontWeight: 600,
                                lineHeight: "20px",
                                letterSpacing: "0.1px",
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                textTransform: "none",
                              }}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="18"
                                height="18"
                                viewBox="0 0 18 18"
                                fill="none"
                              >
                                <path
                                  d="M5.62498 4.2L3.74998 5.25L4.79998 3.375L3.74998 1.5L5.62498 2.55L7.49998 1.5L6.44998 3.375L7.49998 5.25L5.62498 4.2ZM14.625 11.55L16.5 10.5L15.45 12.375L16.5 14.25L14.625 13.2L12.75 14.25L13.8 12.375L12.75 10.5L14.625 11.55ZM16.5 1.5L15.45 3.375L16.5 5.25L14.625 4.2L12.75 5.25L13.8 3.375L12.75 1.5L14.625 2.55L16.5 1.5ZM10.005 9.585L11.835 7.755L10.245 6.165L8.41498 7.995L10.005 9.585ZM10.7775 5.4675L12.5325 7.2225C12.825 7.5 12.825 7.9875 12.5325 8.28L3.77998 17.0325C3.48748 17.325 2.99998 17.325 2.72248 17.0325L0.967483 15.2775C0.674983 15 0.674983 14.5125 0.967483 14.22L9.71998 5.4675C10.0125 5.175 10.5 5.175 10.7775 5.4675Z"
                                  fill="#17182C"
                                />
                              </svg>
                              Create avatar
                            </Typography>
                          </Box>
                        </Button>
                      </Box>
                      <Box
                        sx={{
                          margin: "0px",
                          padding: "0px",
                          display: "flex",
                          flexDirection: "column",
                          rowGap: "8px",
                        }}
                      >
                        <CardMedia
                          sx={{ height: "112px", width: "165px" }}
                          component="img"
                          alt={"Your avatar"}
                          image={Heygen_Avatar_Creation}
                        />
                      </Box>
                    </Box>
                  )}{" "}
                </div>
              </div>
            ) : null}

            {subscribeType >= 3 ? (
              <Box
                sx={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}
              >
                {personalAvatar.length > 0 &&
                  personalAvatar.map((avatar, index) => (
                    <Box key={avatar.id}>
                      <Grid
                        onMouseEnter={() => {
                          setHoverForDeleteButton(true);
                          setHoveredCardIndex(index);
                        }}
                        onMouseLeave={() => {
                          setHoverForDeleteButton(false);
                          setHoveredCardIndex(null);
                        }}
                        item
                        sx={{
                          width: "140px",
                          height: "174px",
                          margin: 1,
                          boxSizing: "border-box",
                        }}
                      >
                        <Box sx={{ position: "relative" }}>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-between",
                              position: "absolute",
                              zIndex: "1000",
                              top: "10px",
                            }}
                          >
                            {avatar?.status === "pending" ||
                            avatar?.status === "moderation_rejected" ||
                            avatar?.status === "started" ? (
                              <Box
                                sx={{
                                  display: "flex",
                                  position: "absolute",
                                  border:
                                    avatar.status === "moderation_rejected"
                                      ? "1px solid rgba(221, 32, 37, 1)"
                                      : "1px solid #CAC4D0",
                                  backgroundColor:
                                    avatar.status === "moderation_rejected"
                                      ? "rgba(221, 32, 37, 0.20)"
                                      : "rgba(202, 196, 208, 0.20)",
                                  width: "74px",
                                  height: "20px",
                                  borderRadius: "4px",
                                  color:
                                    avatar.status === "moderation_rejected"
                                      ? "rgba(221, 32, 37, 1)"
                                      : "rgba(202, 196, 208, 1)",
                                  fontFamily: "Inter",
                                  fontSize: "12px",
                                  fontStyle: "normal",
                                  fontWeight: 600,
                                  lineHeight: "16px",
                                  letterSpacing: "0.1px",
                                  top: "10px",
                                  left: "10px",
                                  zIndex: 20,
                                  textAlign: "center",
                                  justifyContent: "center",
                                }}
                              >
                                {avatar.status === "moderation_rejected"
                                  ? "Rejected"
                                  : "Pending"}
                              </Box>
                            ) : null}

                            {hoverForDeleteButton &&
                              hoveredCardIndex === index && (
                                <Box
                                  onClick={(e) =>
                                    handleClickMoreOption(e, avatar, index)
                                  }
                                  variant="contained"
                                  sx={{
                                    position: "absolute",
                                    zIndex: "1000",
                                    top: "0px",
                                    left: "100px",
                                    backgroundColor: "transparent",
                                    color: "black",
                                    borderRadius: "50%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    padding: "8px",
                                    cursor: "pointer",
                                    "&:hover": {
                                      color: "#2F355F",
                                    },
                                  }}
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                  >
                                    <path
                                      d="M11.875 16.25C11.875 16.7473 11.6775 17.2242 11.3258 17.5758C10.9742 17.9275 10.4973 18.125 10 18.125C9.50272 18.125 9.02581 17.9275 8.67417 17.5758C8.32254 17.2242 8.125 16.7473 8.125 16.25C8.125 15.7527 8.32254 15.2758 8.67417 14.9242C9.02581 14.5725 9.50272 14.375 10 14.375C10.4973 14.375 10.9742 14.5725 11.3258 14.9242C11.6775 15.2758 11.875 15.7527 11.875 16.25ZM11.875 10C11.875 10.4973 11.6775 10.9742 11.3258 11.3258C10.9742 11.6775 10.4973 11.875 10 11.875C9.50272 11.875 9.02581 11.6775 8.67417 11.3258C8.32254 10.9742 8.125 10.4973 8.125 10C8.125 9.50272 8.32254 9.02581 8.67417 8.67417C9.02581 8.32254 9.50272 8.125 10 8.125C10.4973 8.125 10.9742 8.32254 11.3258 8.67417C11.6775 9.02581 11.875 9.50272 11.875 10ZM11.875 3.75C11.875 4.24728 11.6775 4.72419 11.3258 5.07583C10.9742 5.42746 10.4973 5.625 10 5.625C9.50272 5.625 9.02581 5.42746 8.67417 5.07583C8.32254 4.72419 8.125 4.24728 8.125 3.75C8.125 3.25272 8.32254 2.77581 8.67417 2.42417C9.02581 2.07254 9.50272 1.875 10 1.875C10.4973 1.875 10.9742 2.07254 11.3258 2.42417C11.6775 2.77581 11.875 3.25272 11.875 3.75Z"
                                      fill="white"
                                    />
                                  </svg>
                                </Box>
                              )}
                          </Box>

                          {moreOptionIndex === index && (
                            <Box
                              sx={{
                                position: "absolute",
                                top: "30px",
                                left: "100px",
                                zIndex: 1100,
                                backgroundColor: "#2F355F",
                                borderRadius: "8px",
                                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)",
                                border: "1px solid rgba(255, 255, 255, 0.10)",
                                padding: "8px 0",
                                maxWidth: "168px",
                                width: "auto",
                              }}
                            >
                              <Box
                                className="delete-option-container"
                                sx={{
                                  display: "flex", // makes icon and text inline
                                  alignItems: "center", // vertically centers icon and tex
                                  padding: "8px 16px",
                                  color: "white",
                                  fontFamily: "Inter",
                                  fontSize: "14px",
                                  cursor: "pointer",
                                  whiteSpace: "nowrap",
                                  "&:hover": {
                                    backgroundColor:
                                      "rgba(255, 255, 255, 0.10)",
                                    padding: "8px 16px",
                                  },
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setActiveAvatar(avatar);
                                  handleAddLookModalClick();
                                }}
                              >
                                <GroupsIcon
                                  sx={{
                                    color: "rgba(202, 196, 208, 1)",
                                    marginRight: "12px",
                                    "&:hover": {
                                      color: "rgba(202, 196, 208, 1)",
                                    },
                                  }}
                                />
                                Add Looks
                              </Box>
                              <Box
                                className="delete-option-container"
                                sx={{
                                  display: "flex", // makes icon and text inline
                                  alignItems: "center", // vertically centers icon and tex
                                  padding: "8px 16px",
                                  color: "white",
                                  fontFamily: "Inter",
                                  fontSize: "14px",
                                  cursor: "pointer",
                                  whiteSpace: "nowrap",
                                  "&:hover": {
                                    backgroundColor:
                                      "rgba(255, 255, 255, 0.10)",
                                  },
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  openDeleteModal();
                                }}
                              >
                                <DeleteIcon
                                  sx={{
                                    color: "rgba(202, 196, 208, 1)",
                                    marginRight: "12px",
                                    "&:hover": {
                                      color: "rgba(202, 196, 208, 1)",
                                    },
                                  }}
                                />
                                Delete
                              </Box>
                            </Box>
                          )}

                          <Card
                            sx={{
                              margin: "0px",
                              padding: "12px",
                              width: "144px",
                              height: "174px",
                              display: "flex",
                              flexDirection: "column",
                              rowGap: "8px",
                              backgroundColor:
                                (heygenVideoPersonalAvatarImageId ===
                                  avatar.group_id ||
                                  heygenVideoPersonalAvatarGroupId ===
                                    avatar?.group_id) &&
                                (avatar.status !== "pending" ||
                                  avatar?.status !== "moderation_rejected")
                                  ? "#2F355F"
                                  : "#1F233E",
                              borderRadius: "16px",
                              outline:
                                (heygenVideoPersonalAvatarImageId ===
                                  avatar.group_id ||
                                  heygenVideoPersonalAvatarGroupId ===
                                    avatar?.group_id) &&
                                (avatar.status !== "pending" ||
                                  avatar?.status !== "moderation_rejected")
                                  ? "1px solid rgba(255, 255, 255, 0.30)"
                                  : "1px solid rgba(255, 255, 255, 0.10)",
                              cursor: "pointer",
                              boxShadow: "none",
                              "&:hover": {
                                borderRadius: "16px",
                                backgroundColor:
                                  (heygenVideoPersonalAvatarImageId !==
                                    avatar.group_id ||
                                    heygenVideoPersonalAvatarGroupId ===
                                      avatar?.group_id) &&
                                  "#2F355F",
                                outline:
                                  (heygenVideoPersonalAvatarImageId !==
                                    avatar.group_id ||
                                    heygenVideoPersonalAvatarGroupId ===
                                      avatar?.group_id) &&
                                  "1px solid rgba(255, 255, 255, 0.10)",
                              },
                            }}
                            // onClick={() => {(avatar.status !== "pending" || avatar?.status !== "moderation_rejected") && handleAvatarSelect(avatar) }}
                            onClick={() => {
                              if (
                                avatar.status !== "pending" &&
                                avatar.status !== "moderation_rejected"
                              ) {
                                handleAvatarSelect(avatar);
                              }
                            }}
                          >
                            <CardMedia
                              sx={{
                                height: "120px",
                                width: "120px",
                                filter:
                                  (avatar.status == "pending" ||
                                    avatar?.status == "moderation_rejected") &&
                                  "blur(5px)",
                              }}
                              component="img"
                              alt={"Your avatar"}
                              image={avatar?.image_url || defaultImageForAvatar}
                            />
                            {/* <img src={avatar?.image_url || defaultImageForAvatar} alt= ""/> */}
                            <CardContent
                              sx={{
                                padding: "0px",
                                textAlign: "center",
                                margin: "0px",
                                height: "14px",
                              }}
                            >
                              <Typography
                                sx={{
                                  color: "white",
                                  fontFamily: "Inter",
                                  fontSize: "14px",
                                  fontStyle: "normal",
                                  fontWeight: 600,
                                  lineHeight: "normal",
                                  letterSpacing: "0.082px",
                                }}
                              >
                                {avatar?.name ? avatar?.name : "Your Avatar"}
                              </Typography>
                            </CardContent>
                          </Card>
                        </Box>
                      </Grid>
                    </Box>
                  ))}

                {personalAvatar.length > 0 && (
                  <Box
                    onClick={toggleModal}
                    sx={{
                      display: "flex",
                      width: "144px",
                      padding: "37px 27px",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "16px",
                      border: "1px solid rgba(255, 255, 255, 0.10)",
                      margin: 1,
                      cursor: "pointer",
                      "&:hover": {
                        backgroundColor: "#2F355F",
                      },
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        width: "48px",
                        height: "48px",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "8px",
                        borderRadius: "80px",
                        background: "#282D51",
                        marginBottom: "16px",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          padding: "8px",
                          justifyContent: "center",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        <AddIcon
                          sx={{
                            width: "24px",
                            height: "24px",
                            color: "rgba(202, 196, 208, 1)",
                          }}
                        />
                      </Box>
                    </Box>
                    <Typography
                      sx={{
                        color: "#CAC4D0",
                        textAlign: "center",
                        fontFamily: "Inter",
                        fontSize: "14px",
                        fontStyle: "normal",
                        fontWeight: 600,
                        lineHeight: "20px",
                        letterSpacing: "0.1px",
                      }}
                    >
                      Create new avatar
                    </Typography>
                  </Box>
                )}
              </Box>
            ) : null}
          </Box>

          {/* System Avatars Section */}
          <Box sx={{ marginTop: "24px" }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "16px",
              }}
            >
              <Typography
                sx={{
                  color: "#FFF",
                  fontFamily: "Inter",
                  fontSize: "14px",
                  fontStyle: "normal",
                  fontWeight: 500,
                  lineHeight: "20px",
                }}
              >
                System avatars
              </Typography>

              {/* Gender Filter Button */}
              <FormControl>
                <Button
                  onClick={handleOpen}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "8px",
                    color: gender?.name
                      ? "rgba(255, 255, 255, 1)"
                      : "rgba(202, 196, 208, 1)",
                    backgroundColor: open ? "#373E6D" : "#2F355F",
                    borderRadius: "8px",
                    height: "40px",
                    minWidth: "120px",
                    textTransform: "none",
                    fontFamily: "Inter",
                    fontWeight: 400,
                    "&:hover": {
                      backgroundColor: "#373E6D",
                    },
                    transition: "background-color 0.2s ease",
                  }}
                >
                  <span style={{ flex: 1, textAlign: "center" }}>
                    {gender?.name || "Gender"}
                  </span>
                  {open ? (
                    <CloseIcon
                      sx={{
                        color: gender?.id
                          ? "rgba(255, 255, 255, 1)"
                          : "rgba(202, 196, 208, 1)",
                        fontSize: "20px",
                      }}
                    />
                  ) : (
                    <ArrowDropDownIcon
                      sx={{
                        color: gender?.id
                          ? "rgba(255, 255, 255, 1)"
                          : "rgba(202, 196, 208, 1)",
                      }}
                    />
                  )}
                </Button>

                <Popover
                  open={open}
                  anchorEl={anchorEl}
                  onClose={handleClose}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  sx={{
                    "& .MuiPaper-root": {
                      backgroundColor: "#2F355F",
                      color: "white",
                      borderRadius: "8px",
                      boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.2)",
                      maxHeight: "300px",
                      width: "auto",
                      minWidth: "120px",
                      marginTop: "4px",
                    },
                  }}
                >
                  <Box
                    sx={{ overflowY: "auto", maxHeight: 250, padding: "4px" }}
                  >
                    {allFilterVoiceGender?.map((ele) => (
                      <MenuItem
                        key={ele.id}
                        onClick={() => handleSelectGender(ele)}
                        sx={{
                          "&:hover": { backgroundColor: "#373E6D" },
                          "&.Mui-selected": { backgroundColor: "#373E6D" },
                          py: 1,
                          px: 2,
                          fontSize: 14,
                          whiteSpace: "nowrap",
                        }}
                      >
                        {ele.name}
                      </MenuItem>
                    ))}
                  </Box>
                </Popover>
              </FormControl>
            </Box>

            {/* Search Input */}
            {/* <Box sx={{ marginBottom: "20px" }}>
          <Input
            type="text"
            disableUnderline={true}
            placeholder="Search Avatar"
            variant="outlined"
            sx={customTextFieldStyles}
            onChange={(e) => setInputBoxValue(e.target.value)}
            value={inputBoxValue}
            style={{
              width: "100%",
              maxWidth: "180px",
              height: "48px",
              backgroundColor: "#2F355F",
              borderRadius: "8px",
              padding: "0px 12px",
              boxShadow: "0px 0px 80px 0px rgba(0, 0, 0, 0.40)",
            }}
            startAdornment={
              <InputAdornment position="start">
                <SearchIcon style={{ color: "rgba(255, 255, 255, 0.80)" }} />
              </InputAdornment>
            }
          />
        </Box> */}

            {/* System Avatars Grid */}
            {!showSystemAvatarLooks && (
              <Grid mt={3} ml={0} container gap={2}>
                {avatarsLoading ? (
                  <Grid
                    item
                    xs={12}
                    sx={{ display: "flex", justifyContent: "center" }}
                  >
                    <CircularProgress
                      color="secondary"
                      size="30px"
                      style={{ color: "#ffffff" }}
                    />
                  </Grid>
                ) : (
                  (inputBoxValue ? filterAvatars : systemAvatars)?.map(
                    (avatar) => (
                      <Grid
                        key={avatar?.avatar_id}
                        sx={{
                          width: "140px",
                          height: "190px",
                          // margin: 1,
                          margin: "0px",
                          padding: "0px",
                          boxSizing: "border-box",
                        }}
                      >
                        <Card
                          onClick={() => handleSystemAvatarSelect(avatar)}
                          sx={{
                            width: "144px",
                            height: "190px",
                            cursor: "pointer",
                            backgroundColor:
                              selectedAvatarForHeygenVideo?.avatar_id ===
                              avatar?.avatar_id
                                ? "#2F355F"
                                : "#1F233E",
                            outline:
                              selectedAvatarForHeygenVideo?.avatar_id ===
                              avatar?.avatar_id
                                ? "1px solid rgba(255, 255, 255, 0.30)"
                                : "1px solid rgba(255, 255, 255, 0.10)",
                            borderRadius: "16px",
                            padding: "10px",
                            boxShadow: "none",
                            "&:hover": {
                              backgroundColor:
                                selectedAvatarForHeygenVideo?.avatar_id ===
                                  avatar?.avatar_id && "#2F355F",
                              outline:
                                selectedAvatarForHeygenVideo?.avatar_id ===
                                  avatar?.avatar_id &&
                                "1px solid rgba(255, 255, 255, 0.10)",
                            },
                          }}
                        >
                          <CardMedia
                            component="img"
                            alt={avatar?.avatar_name}
                            image={avatar?.preview_image_url}
                            sx={{
                              height: "120px",
                              width: "120px",
                              objectFit: "cover",
                            }}
                          />
                          <CardContent
                            sx={{ padding: "0px", textAlign: "center" }}
                          >
                            <Typography
                              sx={{
                                color:
                                  selectedAvatarForHeygenVideo?.avatar_id ===
                                  avatar?.avatar_id
                                    ? "#ffffff"
                                    : "#CAC4D0",
                                fontFamily: "Inter",
                                fontSize: "14px",
                                fontWeight: 600,
                                lineHeight: "normal",
                                marginTop: "12px",
                              }}
                            >
                              {avatar.avatar_name}
                            </Typography>
                          </CardContent>
                        </Card>
                      </Grid>
                    )
                  )
                )}
              </Grid>
            )}

            {showSystemAvatarLooks && (
              <Box sx={{ marginTop: "20px" }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "16px",
                  }}
                >
                  <ArrowBackIcon
                    sx={{
                      color: "#FFF",
                      cursor: "pointer",
                      marginRight: "12px",
                    }}
                    onClick={handleBackFromLooks}
                  />
                  <Typography
                    sx={{
                      color: "#FFF",
                      fontFamily: "Inter",
                      fontSize: "16px",
                      fontWeight: 500,
                    }}
                  >
                    {selectedSystemAvatar?.avatar_name} - Looks
                  </Typography>
                </Box>

                <Grid container gap={2}>
                  {avatarsLoading ? (
                    <Grid
                      item
                      xs={12}
                      sx={{ display: "flex", justifyContent: "center" }}
                    >
                      <CircularProgress
                        color="secondary"
                        size="30px"
                        style={{ color: "#ffffff" }}
                      />
                    </Grid>
                  ) : (
                    avatarLooks?.map(
                      (
                        look // Use avatarLooks instead of systemAvatars
                      ) => (
                        <Grid
                          key={look?.avatar_id}
                          sx={{
                            width: "140px",
                            height: "190px",
                            margin: "0px",
                            padding: "0px",
                          }}
                        >
                          <Card
                            onClick={() => handleLookSelect(look)}
                            sx={{
                              width: "144px",
                              height: "190px",
                              cursor: "pointer",
                              backgroundColor:
                                selectedAvatarForHeygenVideo?.avatar_id ===
                                look?.avatar_id
                                  ? "#2F355F"
                                  : "#1F233E",
                              outline:
                                selectedAvatarForHeygenVideo?.avatar_id ===
                                look?.avatar_id
                                  ? "1px solid rgba(255,255,255,0.30)"
                                  : "1px solid rgba(255,255,255,0.10)",
                              borderRadius: "16px",
                              padding: "10px",
                              boxShadow: "none",
                              "&:hover": {
                                backgroundColor: "#2F355F",
                                outline: "1px solid rgba(255,255,255,0.10)",
                              },
                            }}
                          >
                            <CardMedia
                              component="img"
                              alt={look?.avatar_name}
                              image={look?.preview_image_url}
                              sx={{
                                height: "120px",
                                width: "120px",
                                objectFit: "cover",
                              }}
                            />
                            <CardContent
                              sx={{ padding: "0px", textAlign: "center" }}
                            >
                              <Typography
                                sx={{
                                  color:
                                    selectedAvatarForHeygenVideo?.avatar_id ===
                                    look?.avatar_id
                                      ? "#ffffff"
                                      : "#CAC4D0",
                                  fontFamily: "Inter",
                                  fontSize: "14px",
                                  fontWeight: 600,
                                  lineHeight: "normal",
                                  marginTop: "12px",
                                }}
                              >
                                {look.avatar_name}
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                      )
                    )
                  )}
                </Grid>
              </Box>
            )}

            {!showSystemAvatarLooks && (
              <div className="d-flex justify-content-center mt-4 mb-3">
                <ThemeProvider theme={paginationTheme}>
                  <Pagination
                    count={totalPage}
                    page={currentPage}
                    siblingCount={1}
                    boundaryCount={1}
                    onChange={handlePageChange}
                    shape="rounded"
                    size="large"
                  />
                </ThemeProvider>
              </div>
            )}
          </Box>

          {/* Delete Confirmation Modal */}
          {showDeleteModal && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(0, 0, 0, 0.7)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 2000,
              }}
            >
              <div
                style={{
                  width: "720px",
                  padding: "24px",
                  borderRadius: "16px",
                  background: "#1F233E",
                  border: "1px solid rgba(255, 255, 255, 0.10)",
                  boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.25)",
                }}
              >
                <Typography
                  sx={{
                    color: "#FFF",
                    fontFamily: "Inter",
                    fontSize: "18px",
                    fontWeight: 600,
                    marginBottom: "16px",
                  }}
                >
                  Delete Avatar
                </Typography>

                <Typography
                  sx={{
                    color: "rgba(255, 255, 255, 0.8)",
                    fontFamily: "Inter",
                    fontSize: "14px",
                    marginBottom: "24px",
                  }}
                >
                  Are you sure you want to delete this avatar? This action
                  cannot be undone.
                </Typography>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "12px",
                  }}
                >
                  <Button
                    onClick={handleCloseDeleteModal}
                    sx={{
                      color: "white",
                      border: "1px solid rgba(255, 255, 255, 0.20)",
                      borderRadius: "8px",
                      padding: "8px 16px",
                      textTransform: "none",
                      "&:hover": {
                        backgroundColor: "rgba(255, 255, 255, 0.10)",
                      },
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={handleDeleteAvatar}
                    sx={{
                      backgroundColor: "#DD2025",
                      color: "white",
                      borderRadius: "8px",
                      padding: "8px 16px",
                      textTransform: "none",
                      "&:hover": {
                        backgroundColor: "#C1191E",
                      },
                    }}
                  >
                    Delete
                  </Button>
                </Box>
              </div>
            </div>
          )}

          {/* Avatar Creation Modal Overlay */}
          {isModalOpenForAvatarGenerationOption && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(0, 0, 0, 0.7)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1000,
              }}
            >
              {showAvatarCreation ? (
                <CreateAvatarFromScript onClose={handleCloseAvatarCreation} />
              ) : showCustomAvatar ? (
                <CustomAvatar
                  onClose={handleCloseCustomAvatar}
                  setPersonalAvatar={setPersonalAvatar}
                  setPersonalAvatarLoader={setPersonalAvatarLoader}
                  pollingIntervalRef={pollingIntervalRef}
                  isFirstCallDoneRef={isFirstCallDoneRef}
                />
              ) : (
                <div
                  style={{
                    maxWidth: "750px",
                    maxHeight: "850px",
                    flexShrink: 0,
                    borderRadius: "16px",
                    border: "1px solid rgba(255, 255, 255, 0.10)",
                    background: "#1F233E",
                    overflow: "hidden",
                    position: "relative",
                  }}
                >
                  {/* Modal Header */}
                  <div
                    style={{
                      display: "flex",
                      width: "750px",
                      padding: "20px",
                      justifyContent: "space-between",
                      alignItems: "center",
                      borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                    }}
                  >
                    <div
                      style={{
                        color: "#FFF",
                        textAlign: "center",
                        fontFamily: "Inter",
                        fontSize: "16px",
                        fontStyle: "normal",
                        fontWeight: "600",
                        lineHeight: "20px",
                      }}
                    >
                      Create your AI avatar
                    </div>
                    <button
                      onClick={toggleModal}
                      style={{
                        background: "transparent",
                        border: "none",
                        color: "white",
                        cursor: "pointer",
                        fontSize: "20px",
                      }}
                    >
                      <ClearIcon />
                    </button>
                  </div>

                  {/* Modal Body */}
                  <div
                    style={{
                      padding: "57px",
                      height: "calc(100% - 61px)",
                      overflowY: "auto",
                    }}
                  >
                    {activeView === "selection" && (
                      <>
                        <h2
                          style={{
                            color: "#FFF",
                            fontFamily: "Inter",
                            fontSize: "24px",
                            fontWeight: "600",
                            marginBottom: "24px",
                          }}
                        >
                          Create Your Avatar
                        </h2>

                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "24px",
                          }}
                        >
                          {/* First Card - Custom Photo Avatar
                      <div 
                        onClick={() => handleOptionSelect('custom')}
                        style={{
                          borderRadius: '16px',
                          border: '1px solid rgba(255, 255, 255, 0.20)',
                          background: 'rgba(40, 45, 81, 0.50)',
                          display: 'flex',
                          width: '100%',
                          padding: '16px',
                          alignItems: 'center',
                          gap: '16px',
                          position: 'relative',
                          overflow: 'hidden',
                          cursor: 'pointer',
                          transition: 'transform 0.2s',
                          ':hover': {
                            transform: 'scale(1.02)'
                          }
                        }}
                      >
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', zIndex: 1 }}>
                          <div style={{ 
                            color: '#FFF',
                            fontFamily: 'Inter',
                            fontSize: '16px',
                            fontWeight: '600'
                          }}>
                            Create a Custom Photo Avatar
                          </div>
                          <div style={{
                            color: 'rgba(255, 255, 255, 0.7)',
                            fontFamily: 'Inter',
                            fontSize: '14px',
                            maxWidth: '380px'
                          }}>
                            Use existing photos to create a new avatar and multiple looks
                          </div>
                        </div>
                        
                        <div style={{
                          background: 'lightgray',
                          position: 'absolute',
                          right: '20px',
                          bottom: '8px',
                          width: '212px',
                          height: '132px',
                          aspectRatio: '53/33',
                          borderRadius: '8px',
                          backgroundImage: 'url(https://example.com/photo-avatar.jpg)',
                          backgroundPosition: '-11.833px -0.926px',
                          backgroundSize: '116.473% 124.708%',
                          backgroundRepeat: 'no-repeat'
                        }} />
                      </div>

                      {/* Second Card - AI Avatar */}
                          {/* <div 
                        onClick={() => handleOptionSelect('ai')}
                        style={{
                          borderRadius: '16px',
                          border: '1px solid rgba(255, 255, 255, 0.20)',
                          background: 'rgba(40, 45, 81, 0.50)',
                          display: 'flex',
                          width: '100%',
                          padding: '16px',
                          alignItems: 'center',
                          gap: '16px',
                          position: 'relative',
                          overflow: 'hidden',
                          cursor: 'pointer',
                          transition: 'transform 0.2s',
                          ':hover': {
                            transform: 'scale(1.02)'
                          }
                        }}
                      >
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', zIndex: 1 }}>
                          <div style={{ 
                            color: '#FFF',
                            fontFamily: 'Inter',
                            fontSize: '16px',
                            fontWeight: '600'
                          }}>
                            Generate an AI Avatar
                          </div>
                          <div style={{
                            color: 'rgba(255, 255, 255, 0.7)',
                            fontFamily: 'Inter',
                            fontSize: '14px',
                            maxWidth: '380px'
                          }}>
                            Generate an avatar by describing its characteristics and appearance with text prompts
                          </div>
                        </div>
                        
                        <div style={{
                          background: 'lightgray',
                          position: 'absolute',
                          right: '20px',
                          bottom: '8px',
                          width: '212px',
                          height: '132px',
                          aspectRatio: '53/33',
                          borderRadius: '8px',
                          backgroundImage: 'url(https://example.com/ai-avatar.jpg)',
                          backgroundPosition: '-11.833px -0.926px',
                          backgroundSize: '116.473% 124.708%',
                          backgroundRepeat: 'no-repeat'
                        }} />
                      </div>  */}

                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "24px",
                            }}
                          >
                            {/* First Card - Custom Photo Avatar */}
                            <div
                              onClick={() => handleOptionSelect("custom")}
                              style={{
                                borderRadius: "16px",
                                border: "1px solid rgba(255, 255, 255, 0.20)",
                                background: "rgba(40, 45, 81, 0.50)",
                                display: "flex",
                                width: "100%",
                                // alignItems: 'center',
                                // gap: '16px',
                                position: "relative",
                                overflow: "hidden",
                                cursor: "pointer",
                                transition: "transform 0.2s",
                                ":hover": {
                                  transform: "scale(1.02)",
                                },
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "8px",
                                  zIndex: 1,
                                  padding: "16px",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    width: "40px",
                                    height: "40px",
                                    backgroundColor: "#373E6D",
                                    borderRadius: "50%",
                                  }}
                                >
                                  <PeopleAltOutlinedIcon />
                                </div>
                                <div
                                  style={{
                                    color: "#FFF",
                                    fontFamily: "Inter",
                                    fontSize: "16px",
                                    fontWeight: "600",
                                  }}
                                >
                                  Create a Custom Photo Avatar
                                </div>
                                <div
                                  style={{
                                    color: "rgba(255, 255, 255, 0.7)",
                                    fontFamily: "Inter",
                                    fontSize: "14px",
                                    maxWidth: "380px",
                                  }}
                                >
                                  Use existing photos to create a new avatar and
                                  multiple looks
                                </div>
                              </div>

                              {/* <div style={{
                          background: 'lightgray',
                          position: 'absolute',
                          right: '20px',
                          bottom: '8px',
                          width: '212px',
                          height: '132px',
                          aspectRatio: '53/33',
                          borderRadius: '8px',
                          backgroundImage: 'url(https://example.com/photo-avatar.jpg)',
                          backgroundPosition: '-11.833px -0.926px',
                          backgroundSize: '116.473% 124.708%',
                          backgroundRepeat: 'no-repeat'
                        }} /> */}

                              <div
                                style={{
                                  border: "",
                                  padding: "19px 16px 0px 0px",
                                }}
                              >
                                <img
                                  width={"200px"}
                                  height={"136px"}
                                  src={introimage}
                                  alt="ai"
                                />
                              </div>
                            </div>

                            {/* Second Card - AI Avatar */}
                            <div
                              onClick={() => handleOptionSelect("ai")}
                              style={{
                                borderRadius: "16px",
                                border: "1px solid rgba(255, 255, 255, 0.20)",
                                background: "rgba(40, 45, 81, 0.50)",
                                display: "flex",
                                width: "100%",
                                padding: "16px",
                                alignItems: "center",
                                gap: "16px",
                                position: "relative",
                                overflow: "hidden",
                                cursor: "pointer",
                                transition: "transform 0.2s",
                                ":hover": {
                                  transform: "scale(1.02)",
                                },
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "8px",
                                  zIndex: 1,
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    width: "40px",
                                    height: "40px",
                                    backgroundColor: "#373E6D",
                                    borderRadius: "50%",
                                  }}
                                >
                                  <AutoFixHighOutlinedIcon />
                                </div>
                                <div
                                  style={{
                                    color: "#FFF",
                                    fontFamily: "Inter",
                                    fontSize: "16px",
                                    fontWeight: "600",
                                  }}
                                >
                                  Generate an AI Avatar
                                </div>
                                <div
                                  style={{
                                    color: "rgba(255, 255, 255, 0.7)",
                                    fontFamily: "Inter",
                                    fontSize: "14px",
                                    maxWidth: "380px",
                                  }}
                                >
                                  Generate an avatar by describing its
                                  characteristics and appearance with text
                                  prompts
                                </div>
                              </div>

                              {/* <div style={{
                          background: 'lightgray',
                          position: 'absolute',
                          right: '20px',
                          bottom: '8px',
                          width: '212px',
                          height: '132px',
                          aspectRatio: '53/33',
                          borderRadius: '8px',
                          backgroundImage: 'url(https://example.com/ai-avatar.jpg)',
                          backgroundPosition: '-11.833px -0.926px',
                          backgroundSize: '116.473% 124.708%',
                          backgroundRepeat: 'no-repeat'
                        }} /> */}
                              <div sx={{ border: "1px solid red" }}>
                                <img
                                  width={"212px"}
                                  height={"132px"}
                                  src={secondoption}
                                  alt="ai"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      ) : (
        <Box sx={{ padding: "20px 20px 0px 0px" }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <Box
              sx={{ display: "flex", flexDirection: "row", columnGap: "12px" }}
            >
              <ArrowBackIcon
                sx={{ cursor: "pointer" }}
                onClick={() => {
                  setCurrentWindow(1);
                }}
              />
              <Typography
                sx={{
                  fontFamily: "Inter",
                  fontSize: "16px",
                  fontStyle: "normal",
                  fontWeight: 500,
                  lineHeight: "20px",
                }}
              >
                Advanced voice settings
              </Typography>
            </Box>
            <Box>
              <Button
                onClick={HandleResetButtonClick}
                sx={{
                  color: "#ffffff",
                  fontFamily: "Inter",
                  fontStyle: "normal",
                  fontWeight: 500,
                  display: "flex",
                  textTransform: "none",
                  lineHeight: "20px",
                }}
              >
                Reset to defaults
              </Button>
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Box>
              <Box sx={{ mt: 3, maxWidth: "160px", width: "100%" }}>
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontSize: "14px",
                    fontStyle: "normal",
                    fontWeight: 500,
                    lineHeight: "140%",
                    letterSpacing: "0.1px",
                  }}
                >
                  Avatar scale
                </Typography>
                <Box>
                  <Slider
                    value={heygenAvatarScale}
                    onChange={(e) => {
                      setHeygenAvatarScale(e.target.value);
                    }}
                    min={0}
                    max={5.0}
                    step={0.01}
                    valueLabelDisplay="auto"
                    sx={{
                      marginTop: "20px",
                      color: "white", // This sets the color for the active (left) track and thumb
                      "& .MuiSlider-thumb": {
                        backgroundColor: "white", // Thumb color to white
                        border: "2px solid white", // Optional border for better visibility
                      },
                      "& .MuiSlider-track": {
                        backgroundColor: "white", // Left side of the slider track
                      },
                      "& .MuiSlider-rail": {
                        backgroundColor: "gray", // Right side of the slider track
                      },
                    }}
                  />
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "Inter",
                        fontSize: "14px",
                        fontWeight: 400,
                      }}
                    >
                      0
                    </Typography>
                    <Typography
                      sx={{
                        fontFamily: "Inter",
                        fontSize: "14px",
                        fontWeight: 400,
                      }}
                    >
                      5.0
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box sx={{ mt: 3, maxWidth: "160px", width: "100%" }}>
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontSize: "14px",
                    fontStyle: "normal",
                    fontWeight: 500,
                    lineHeight: "140%",
                    letterSpacing: "0.1px",
                  }}
                >
                  Offset
                </Typography>
                <Box sx={{ marginTop: "15px" }}>
                  <Typography
                    sx={{
                      fontFamily: "Inter",
                      fontSize: "14px",
                      fontStyle: "normal",
                      fontWeight: 500,
                      lineHeight: "140%",
                      letterSpacing: "0.1px",
                    }}
                  >
                    X-axis
                  </Typography>
                  <Box>
                    <Slider
                      value={heygenAvatarOffset?.x}
                      onChange={(e) => {
                        setHeygenAvatarOffset({
                          ...heygenAvatarOffset,
                          x: e.target.value,
                        });
                      }}
                      min={-1.0}
                      max={1.0}
                      step={0.01}
                      valueLabelDisplay="auto"
                      sx={{
                        width: "160px",
                        marginTop: "10px",
                        color: "white", // This sets the color for the active (left) track and thumb
                        "& .MuiSlider-thumb": {
                          backgroundColor: "white", // Thumb color to white
                          border: "2px solid white", // Optional border for better visibility
                        },
                        "& .MuiSlider-track": {
                          backgroundColor: "white", // Left side of the slider track
                        },
                        "& .MuiSlider-rail": {
                          backgroundColor: "gray", // Right side of the slider track
                        },
                      }}
                    />
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                      }}
                    >
                      <Typography
                        sx={{
                          fontFamily: "Inter",
                          fontSize: "14px",
                          fontWeight: 400,
                        }}
                      >
                        -1.0
                      </Typography>
                      <Typography
                        sx={{
                          fontFamily: "Inter",
                          fontSize: "14px",
                          fontWeight: 400,
                        }}
                      >
                        1.0
                      </Typography>
                    </Box>
                  </Box>
                </Box>
                <Box sx={{ marginTop: "10px" }}>
                  <Typography
                    sx={{
                      fontFamily: "Inter",
                      fontSize: "14px",
                      fontStyle: "normal",
                      fontWeight: 500,
                      lineHeight: "140%",
                      letterSpacing: "0.1px",
                    }}
                  >
                    Y-axis
                  </Typography>
                  <Box>
                    <Slider
                      value={heygenAvatarOffset?.y}
                      //  onChange={(e)=>{setYAxisValue(e.target.value)}}
                      onChange={(e) => {
                        setHeygenAvatarOffset({
                          ...heygenAvatarOffset,
                          y: e.target.value,
                        });
                      }}
                      min={-1.0}
                      max={1.0}
                      step={0.01}
                      valueLabelDisplay="auto"
                      sx={{
                        marginTop: "10px",
                        color: "white", // This sets the color for the active (left) track and thumb
                        "& .MuiSlider-thumb": {
                          backgroundColor: "white", // Thumb color to white
                          border: "2px solid white", // Optional border for better visibility
                        },
                        "& .MuiSlider-track": {
                          backgroundColor: "white", // Left side of the slider track
                        },
                        "& .MuiSlider-rail": {
                          backgroundColor: "gray", // Right side of the slider track
                        },
                      }}
                    />
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                      }}
                    >
                      <Typography
                        sx={{
                          fontFamily: "Inter",
                          fontSize: "14px",
                          fontWeight: 400,
                        }}
                      >
                        -1.0
                      </Typography>
                      <Typography
                        sx={{
                          fontFamily: "Inter",
                          fontSize: "14px",
                          fontWeight: 400,
                        }}
                      >
                        1.0
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
            <Box sx={{}}>
              <Typography>Preview</Typography>
              <Box
                sx={{
                  marginTop: "20px",
                  display: "flex",
                  flexDirection: "column",
                  bgcolor: "#ffffff",
                  width: "400px",
                  height: "225px",
                  overflow: "hidden",
                  position: "relative",
                }}
              >
                <img
                  src={preview_image}
                  alt="avatarPreview"
                  style={{
                    position: "absolute",
                    transform: `scale(${heygenAvatarScale}) translate(${
                      heygenAvatarOffset?.x * 400
                    }px, ${heygenAvatarOffset?.y * 225}px)`,
                    transformOrigin: "center", // Scale from the center
                    width: "100%", // Original image size
                    height: "100%", // Original image size
                    objectFit: "contain",
                    transition: "transform 0.2s ease", // Smooth transition for changes
                  }}
                />
              </Box>
              <Box
                sx={{
                  position: "absolute",
                  marginTop: "20px",
                  width: "400px",
                  display: "flex",
                  flexDirection: "row",
                  columnGap: "8px",
                }}
              >
                <InfoOutlinedIcon sx={{ width: "16px", height: "16px" }} />
                <Typography
                  sx={{
                    display: "flex",
                    fontFamily: "Inter",
                    fontStyle: "normal",
                    fontSize: "13px",
                    fontWeight: 400,
                    lineHeight: "18px",
                  }}
                >
                  This is a sample avatar for preview purposes. It does not
                  represent your actual selected avatar.
                </Typography>
              </Box>
            </Box>
          </Box>
          {/* <Box sx={{mt:3}}>
        <Typography>Avatar style</Typography>
        <Box container spacing={2} mt={2} justifyContent="start" sx={{display:"flex", flexDirection:"row", columnGap:"12px"}}>
          {AvatarStyle?.map((style, index) => (
            <Box item key={index} sx={{}}>
              <Button
                variant="outlined"
                onClick={() =>{handleScaleSelectionButtonClick(style)}}
                sx={{
                  // width: "54px",
                  // height: "32px",
                  textTransform:"none",
                  backgroundColor:
                  selectedHeygenAvatarStyle?.id === style?.id ? "#3a3f69" : "#30355f",
                  // backgroundColor: theme === 'dark'? '#30355f' : '',
                  color: theme === "dark" ? "white" : "black",
                  "&:hover": {
                    backgroundColor: "#373E6D", 
                    border:" 1px solid #373E6D"
                  },
                  borderColor:
                  selectedHeygenAvatarStyle.id === style.id
                      ? "#cac4d0"
                      : "transparent",
                    mx: 0.5, // Add horizontal margin for spacing
                }}
              >
                {style?.name}
              </Button>
            </Box>
          ))}
        </Box>
        </Box> */}
        </Box>
      )}
      <CommonToast
        open={openToast}
        onClose={onClose}
        content={content}
        iconType={iconType}
        bgColor={bgColor}
      />
      {openAddLookModal && (
        <AddLook
          open={openAddLookModal}
          handleClose={handleAddLookModalClose}
          currentAvatar={activeAvatar}
        />
      )}
    </>
  );
};

export default AvatarCreation;
